import { AuthTokenHeader, FetchClient } from '@vp/fetch-client';

import { getAllViews } from '../../../infrastructure/clients/lookupPreviewClient';
import { Combination } from '../domain/Combination';
const defaultPurpose = 'design.studio.review';

export const getBestScenePurpose = async (
  tenant: string,
  productKey: string,
  productVersion: number,
  combination: Combination,
  isSceneImprovementsEnabled: boolean,
  fetchClient: FetchClient,
  tokenConfig: AuthTokenHeader
): Promise<string> => {
  if (!combination.isInitial || !isSceneImprovementsEnabled) return defaultPurpose;
  try {
    const lookupPreviewResponse = await getAllViews(
      tenant,
      productKey,
      productVersion,
      combination.combination,
      fetchClient,
      tokenConfig
    );
    if (lookupPreviewResponse.isFailed) {
      return defaultPurpose;
    }
    const frontViews = lookupPreviewResponse.result.views.filter((view) =>
      view.name?.toLowerCase().includes('front')
    );
    const views = frontViews.length > 0 ? frontViews : lookupPreviewResponse.result.views;
    const preferredPurposes = ['merchandising.cross-sell.tile', 'channel.merchandisingfeeds.pla'];

    for (const purpose of preferredPurposes) {
      const matchingView = views.find((view) => view.subPurpose === purpose);
      if (matchingView) {
        return matchingView.subPurpose!;
      }
    }
    return defaultPurpose;
  } catch {
    return defaultPurpose;
  }
};
